(function () {
  'use strict';

  var HINT_TEXT = 'Please pick a color first';

  function colorSelected() {
    return !!document.querySelector('input[name="Color"]:checked');
  }

  function showHint(btn) {
    document.querySelectorAll('.vto-hint').forEach(function (n) { n.remove(); });
    var rect = btn.getBoundingClientRect();
    var tip = document.createElement('div');
    tip.className = 'vto-hint';
    tip.textContent = HINT_TEXT;
    tip.style.top = (window.scrollY + rect.bottom + 8) + 'px';
    document.body.appendChild(tip);
    var left = Math.min(window.scrollX + rect.left,
                        window.scrollX + window.innerWidth - tip.offsetWidth - 12);
    tip.style.left = Math.max(8, left) + 'px';

    setTimeout(function () { tip.remove(); }, 2500);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.auglio-tryon-btn');
    if (!btn) return;
    if (!colorSelected()) {
      e.preventDefault();
      e.stopImmediatePropagation(); // block Auglio until a color is picked
      showHint(btn);
    }
  }, true);
})();

// Preview try-on override: ?tryon=1 reveals the button anywhere (sets a cookie);
// ?tryon=0 clears it.
(function () {
  var p = new URLSearchParams(location.search);
  if (p.get('tryon') === '1') {
    document.cookie = 'tryon_override=1; path=/; max-age=31536000'; // 1 year
  } else if (p.get('tryon') === '0') {
    document.cookie = 'tryon_override=; path=/; max-age=0';          // clear
  }
  if (/(?:^|;\s*)tryon_override=1(?:;|$)/.test(document.cookie)) {
    document.documentElement.classList.add('tryon-ok');
  }
})();